import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import { OidcProvider } from "@axa-fr/react-oidc";
import configuration from "./utils/oidc-config";
import RouterList from "./RouterList";
import LoadingMessage from "./utils/LoadingMessage";
import SessionTimeout from "./components/SessionTimeout";
import { RoleProvider } from "./Context/RoleContext";
import LoginSuccessLogger from "./components/LoginSuccessLogger";

function App() {
  const today = new Date();
  console.log("App Component Loaded.. at ", today);

  return (
    <OidcProvider
      configuration={configuration}
      authenticatingComponent={() => null}
      loadingComponent={LoadingMessage}
      callbackSuccessComponent={() => null}
    >
      <RoleProvider>
        <SessionTimeout />
        <Router>
          <div>
            <Header />
            <LoginSuccessLogger />
            <RouterList />
          </div>
        </Router>
      </RoleProvider>
    </OidcProvider>
  );
}

export default App;
